import React, { useCallback } from "react";
import { useForm } from "antd/es/form/Form";
import { Button } from "antd";
import { inject, observer } from "mobx-react";
import config from "./config";
import Field from "../../common/forms/field";
import Form from "../../common/forms/form";
import { IAppStore } from "../../../stores/Interfaces";

interface Props {
  store?: IAppStore;
  onShowResetModal: () => void;
  onLogin: () => void;
}

const LoginForm: React.FC<Props> = ({
  store: { userStore } = {},
  onShowResetModal,
  onLogin,
}) => {
  const [form] = useForm();

  const onFinishHandler = useCallback(
    (values) => {
      if (!userStore) {
        return;
      }

      userStore.login(values.email, values.password).then(() => {
        if (
          Object.keys(userStore.errors).length === 0 &&
          userStore.isSuccessRequest
        ) {
          onLogin();
        }
      });
    },
    [onLogin, userStore]
  );

  const errors = userStore
    ? (userStore.errors as { [key: string]: string[] | null })
    : {};

  const showResetPasswordForm = useCallback(() => {
    onShowResetModal();
  }, [onShowResetModal]);

  return (
    <Form
      config={config}
      errors={errors}
      onFinishHandler={onFinishHandler}
      form={form}
    >
      <Field name="email" />
      <Field name="password" />

      <Button type="primary" htmlType="submit" className="login-form__btn">
        Submit
      </Button>

      <Button
        type="link"
        onClick={showResetPasswordForm}
        className="btn-center"
      >
        Forgot password?
      </Button>
    </Form>
  );
};

export default inject("store")(observer(LoginForm));
